var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTcaHeroCropped(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "56.11 205.82 387.78 221.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-2",
    cx: 250,
    cy: 413.8,
    rx: 193.89,
    ry: 13.77,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble-2--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M388.66,205.82h-27a9.27,9.27,0,0,0-9.27,9.27v11.18a9.27,9.27,0,0,0,9.27,9.27h11.54l3.1,9.79,3.13-9.79h9.18a9.27,9.27,0,0,0,9.27-9.27V215.09A9.27,9.27,0,0,0,388.66,205.82Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.68,220a1.87,1.87,0,1,1-1.87-1.87A1.87,1.87,0,0,1,364.68,220Zm6.38-1.87a1.87,1.87,0,1,0,1.87,1.87A1.87,1.87,0,0,0,371.06,218.17Zm8.25,0a1.87,1.87,0,1,0,1.87,1.87A1.87,1.87,0,0,0,379.31,218.17Zm8.25,0a1.87,1.87,0,1,0,1.87,1.87A1.87,1.87,0,0,0,387.56,218.17Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble-1--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.5,238.82H84.55a9.27,9.27,0,0,0-9.27,9.27v11.18a9.27,9.27,0,0,0,9.27,9.27H96.09l3.1,9.78,3.13-9.78h9.18a9.27,9.27,0,0,0,9.27-9.27V248.09A9.27,9.27,0,0,0,111.5,238.82Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.52,253a1.87,1.87,0,1,1-1.87-1.87A1.87,1.87,0,0,1,87.52,253Zm6.38-1.87A1.87,1.87,0,1,0,95.77,253,1.86,1.86,0,0,0,93.9,251.17Zm8.25,0A1.87,1.87,0,1,0,104,253,1.86,1.86,0,0,0,102.15,251.17Zm8.25,0a1.87,1.87,0,1,0,1.87,1.87A1.86,1.86,0,0,0,110.4,251.17Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-4--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M413,415.2H286.08c-23.71,0-25.23-27.92-5.74-41.06A37.31,37.31,0,0,1,292,369c38.59-10.15,92.81-78.38,131-49.83l.11.08C461.15,348,434.56,415.2,413,415.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413,415.2H286.08c-23.71,0-25.23-27.92-5.74-41.06A37.31,37.31,0,0,1,292,369c38.59-10.15,92.81-78.38,131-49.83l.11.08C461.15,348,434.56,415.2,413,415.2Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.9,319.12c-3.2-.21-7.08.69-11.26,4.19-10.85,9.1,5.65,52.91-20.3,71.13-14.48,10.17-76.95,14.65-97.8,2.18-15.39-9.21-15.59-15-13.2-22.48A37.31,37.31,0,0,1,292,369C330.54,358.8,384.76,290.57,422.9,319.12Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--group--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M324.22,310.86l-7.57-5.33,5.66-5.79s5.81,3,5.26,8.35Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "313.68 299.65 318.93 296.35 322.31 299.74 316.65 305.53 313.68 299.65",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.46,297.09c-7.17,2.11-10.7,14.72-16.62,26.63L327.61,306.6l-5.48,4.86s15.78,25.07,23.23,25.07c9.3,0,18.95-25.83,18.95-25.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.31,310.7s-1.53,4.09-4,9c-2.35,4.78-5.55,10.35-9,13.72-1.95,1.89-4,3.09-6,3.09-7.45,0-23.23-25.07-23.23-25.07l5.48-4.86,17.23,17.12c5.92-11.91,9.44-24.52,16.63-26.63Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.35,319.72c-2.35,4.78-5.55,10.35-9,13.72.37-11.43,6-22.58,6-22.58A24.83,24.83,0,0,1,360.35,319.72Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.6,366.75s-60.85-8.74-64.07,4.61C287.14,385.48,336,395,365.2,396s37.58-6,32.89-42h-40Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.6,366.75s-60.85-8.74-64.07,4.61C287.14,385.48,336,395,365.2,396s37.58-6,32.89-42h-40Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "320.71 394.59 307.96 394.6 301.84 394.61 301.11 388.16 306.77 387.4 320.6 385.56 320.71 394.59",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.49,387.35l1.55,7.36a.73.73,0,0,1-.59.88l-3.67.66s-4.87,1.24-6.24.37c-4-2.56-7.84-18.74-6.21-19.94.59-.44,1.62.23,2.14.76,1.64,1.67,5.13,6.34,6.52,7.72,1.61,1.62,4.48,1.67,5.74,1.6A.74.74,0,0,1,302.49,387.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "320.71 394.59 307.96 394.6 306.77 387.4 320.6 385.56 320.71 394.59",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "339.35 383.21 351.45 387.24 357.26 389.17 355.91 395.51 350.3 394.44 336.6 391.82 339.35 383.21",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.35,395.84l.85-7.47a.75.75,0,0,1,.84-.65l3.69.54s5,.36,6,1.62c3,3.69,1.52,20.26-.4,20.88-.71.23-1.47-.73-1.8-1.39-1-2.11-2.86-7.65-3.74-9.39-1-2.05-3.73-3-4.94-3.34A.73.73,0,0,1,354.35,395.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "339.35 383.21 351.45 387.24 350.3 394.44 336.6 391.82 339.35 383.21",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "348.2 395.56 344.75 395.89 346.81 383.95 350.77 386.04 348.2 395.56",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "348.2 395.56 344.75 395.89 346.81 383.95 350.77 386.04 348.2 395.56",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.75,399.89a2.65,2.65,0,0,1-.23,1.59,1,1,0,0,1-.9.45.61.61,0,0,1-.54-.28c-.52-.88.7-3.59.85-3.89a.14.14,0,0,1,.16-.1.18.18,0,0,1,.16.14A10.61,10.61,0,0,1,359.75,399.89Zm-1.44,1.3a.57.57,0,0,0,.08.25.2.2,0,0,0,.21.11.64.64,0,0,0,.62-.3,4.23,4.23,0,0,0-.15-2.89A8.2,8.2,0,0,0,358.31,401.19Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.28,397.82l0,.08c-.33.87-1.83,2.59-2.68,2.47a.63.63,0,0,1-.52-.58,1,1,0,0,1,.14-.83c.62-1,2.77-1.32,2.89-1.31a.16.16,0,0,1,.17.08A.18.18,0,0,1,359.28,397.82Zm-2.88,1.83v.08c.06.25.16.26.21.28.5.07,1.65-1.05,2.15-1.91a3.89,3.89,0,0,0-2.26,1.09.75.75,0,0,0-.11.46Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.12,386.47s56.61-22,73.95-18.32,17.42,12.75,8.63,21.21-21.92,5.2-21.92,5.2,10.32-6.18,9.6-10-7.28,4.91-7.28,4.91-34.21,8.37-62.46,6.16Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.38,385.28a2.58,2.58,0,0,1-.52-1.51,1,1,0,0,1,.58-.82.63.63,0,0,1,.61,0c.86.55,1,3.52,1,3.86a.15.15,0,0,1-.1.16.19.19,0,0,1-.21,0A10.38,10.38,0,0,1,296.38,385.28Zm.68-1.82a.66.66,0,0,0-.19-.18.2.2,0,0,0-.23,0,.64.64,0,0,0-.42.55,4.19,4.19,0,0,0,1.47,2.49A8.3,8.3,0,0,0,297.06,383.46Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.74,386.9v-.09c-.1-.92.43-3.14,1.25-3.43a.63.63,0,0,1,.73.28,1.11,1.11,0,0,1,.26.8c-.1,1.17-1.86,2.44-2,2.5a.17.17,0,0,1-.19,0A.16.16,0,0,1,297.74,386.9Zm1.72-2.95,0-.07c-.16-.19-.26-.15-.31-.14-.48.16-1,1.68-1,2.68.49-.41,1.44-1.27,1.5-2a.76.76,0,0,0-.12-.46Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.12,386.47s56.61-22,73.95-18.32,17.42,12.75,8.63,21.21-21.92,5.2-21.92,5.2,10.32-6.18,9.6-10-7.28,4.91-7.28,4.91-34.21,8.37-62.46,6.16Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "308.43 386.3 311.61 384.84 313.44 396.75 309.02 396.03 308.43 386.3",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "308.43 386.3 311.61 384.84 313.44 396.75 309.02 396.03 308.43 386.3",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.11,299c-6.11,34-3.89,56-3.89,56s-28.43-.39-40.11-1.05c-6.23-41.21,3.35-56.87,3.35-56.87a76.17,76.17,0,0,1,9.25-1.27c.65-.05,1.32-.08,2-.11a144.94,144.94,0,0,1,16.49.93c1,.11,2.09.25,3.11.4C397.52,297.82,402.11,299,402.11,299Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.11,299c-.76,4.22-1.39,8.26-1.91,12.08-.82,6-1.37,11.56-1.73,16.5-.11,1.49-.21,2.94-.28,4.32-.29,5.06-.37,9.39-.36,12.89,0,6.58.39,10.21.39,10.21s-28.43-.39-40.11-1.05c-6.24-41.21,3.36-56.87,3.36-56.87a75.81,75.81,0,0,1,9.24-1.27c.65-.05,1.32-.08,2-.11a142.67,142.67,0,0,1,16.49.93c1,.11,2.09.25,3.11.4C397.52,297.81,402.11,299,402.11,299Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.72,336.53a117.35,117.35,0,0,0,21.47-4.62c-.29,5.06-.37,9.39-.36,12.89-13.57,1.25-19.11-1.36-19.11-1.36Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.2,311.09c-.82,6-1.37,11.56-1.73,16.5-3.89-7.92-1-17.42-1-17.42Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.26,350.49H357.58A1.61,1.61,0,0,1,356,349l-2.88-27.45a1.31,1.31,0,0,1,1.32-1.45h20.68a1.61,1.61,0,0,1,1.57,1.45L379.58,349A1.31,1.31,0,0,1,378.26,350.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.26,350.49H357.58A1.61,1.61,0,0,1,356,349l-2.88-27.45a1.31,1.31,0,0,1,1.32-1.45h20.68a1.61,1.61,0,0,1,1.57,1.45L379.58,349A1.31,1.31,0,0,1,378.26,350.49Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.4,350.49H357.58A1.61,1.61,0,0,1,356,349l-2.88-27.45a1.31,1.31,0,0,1,1.32-1.45h19.82a1.61,1.61,0,0,1,1.57,1.45L378.72,349A1.31,1.31,0,0,1,377.4,350.49Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.34,333.07a2,2,0,0,0-2,2.25,2.48,2.48,0,0,0,2.43,2.24,2,2,0,0,0,2-2.24A2.49,2.49,0,0,1,365.34,333.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.82,322.32H358.89a1.44,1.44,0,0,1-1.28-.82l-.65-1.36h14.42L371,321.5A1.15,1.15,0,0,1,369.82,322.32Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.24,335.65l-4.78-.39.2,6.36,4,2.1,9.22-.84.75-4.29C382.6,334.15,376.24,335.65,376.24,335.65Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.11,299c4.91,1.48,11.87,30,10.76,36.3s-13.22,9-28.61,8.65v-7.44l17.85-5.21-3-11s-2.48-8.09-1.37-13.75A13.91,13.91,0,0,1,402.11,299Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.11,299c4.91,1.48,11.87,30,10.76,36.3s-13.22,9-28.61,8.65v-7.44l17.85-5.21-3-11s-2.48-8.09-1.37-13.75A13.91,13.91,0,0,1,402.11,299Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.82,296.31c-2.49,2.6-6.4,4.78-12.67,4.55-4.81-.19-5.48-3.21-4.64-4.87,2.92-.6,4.24-1.87,4.65-3.49s-.16-3.8-1-5.82l8.11-6.83,1.37-1.16c0,.39-.05.8-.07,1.23a40,40,0,0,0,0,4.76C382.84,289.15,383.9,294,386.82,296.31Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.58,284.68c-1.51,3.09-4.16,6.82-8.42,7.82.44-1.72-.16-3.8-1-5.82l8.11-6.83c.43,0,.87,0,1.3.07A40,40,0,0,0,382.58,284.68Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364,266.27c-1.19,2.72-1.34,8.56,2.8,7.11S366,261.6,364,266.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.83,272.3c-.36,7.28-.19,11.57-3.83,15.32-5.48,5.64-14.52,2.32-16.36-4.94-1.64-6.55-.78-17.36,6.32-20.28A10.07,10.07,0,0,1,383.83,272.3Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.79,274.36c0,.59-.3,1.08-.69,1.08s-.71-.48-.72-1.08.31-1.07.69-1.07S372.78,273.77,372.79,274.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.07,274.38c0,.59-.3,1.07-.69,1.07s-.71-.48-.71-1.07.3-1.07.69-1.07S366.07,273.78,366.07,274.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.21,274.67a20.34,20.34,0,0,1-2.82,4.9,3.54,3.54,0,0,0,2.83.47Z",
    style: {
      fill: "#de5753"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.83,272.19a.34.34,0,0,1-.32-.13,2.82,2.82,0,0,0-2.25-1.16.36.36,0,0,1-.38-.32.35.35,0,0,1,.32-.38,3.53,3.53,0,0,1,2.86,1.43.35.35,0,0,1-.06.49A.36.36,0,0,1,374.83,272.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.15,272.08a.36.36,0,0,1-.2,0,.35.35,0,0,1-.16-.47,3.44,3.44,0,0,1,2.48-2,.35.35,0,0,1,.39.31.34.34,0,0,1-.29.39,2.65,2.65,0,0,0-1.95,1.57A.37.37,0,0,1,363.15,272.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.39,266.46s2-1.44,2.92.11.86,5.68.86,5.68l.4-.73s2.59,9.2,6.34,6.88,9.26-11.66.5-16.42c0,0-.93-2.22-6.72-3.32s-12.79,2.48-14,6.31.48,6,.48,6a5.41,5.41,0,0,1,1.11-2.27,2.41,2.41,0,0,0,1.45,1.76,4.17,4.17,0,0,1,.47-2.26,4.72,4.72,0,0,0,1,1.84c.42-3.94,3.1-4.74,3.94-4.71A1.44,1.44,0,0,1,372.39,266.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.72,278.33a6.87,6.87,0,0,1-3.38,4.06c-2.16,1.11-3.74-.72-3.56-3,.16-2.07,1.47-5.14,3.84-5.29A3.15,3.15,0,0,1,386.72,278.33Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.45,282.48a18.29,18.29,0,0,1,1.72,2.09l.43-.21c1.93-1,2.51-2.07,2.56-3a2.87,2.87,0,0,0-.27-1.3,2.62,2.62,0,0,0-.4-.64,10.1,10.1,0,0,1-3.39,2.7C368.71,282.36,368.45,282.48,368.45,282.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.1,282.14l.53.6c1.81-.92,3-1.82,3.26-2.66a2.62,2.62,0,0,0-.4-.64A10.1,10.1,0,0,1,369.1,282.14Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.6,284.36c1.93-1,2.51-2.07,2.56-3a7,7,0,0,0-1.93,1.51A2.61,2.61,0,0,0,370.6,284.36Z",
    style: {
      fill: "#a24e3f"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M194.41,306.18l.52,5.55s32.48,4.94,37.68,10,23.65,85.09,23.65,85.09l-7.44,1s-25.82-59-27.2-67.54c0,0-22.74.85-38.26.85s-17.37-35-17.37-35Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.26,406.83l-7.44,1s-10.56-24.13-18.53-43.76c-4.51-11.07-8.18-20.71-8.67-23.79,0,0-15.74.58-30,.78-2.88,0-5.69.06-8.3.06-15.52,0-17.37-35-17.37-35h28.42l.52,5.55s32.49,4.93,37.68,10S256.26,406.83,256.26,406.83Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262,414c-5,0-5.67-.08-8.49-.18-2.41-.08-3,.22-4.92.18-1.62,0-1.56-1.59-1.06-3.37.25-.9.63-2.79,1-4.23l7.34-.54c1,2,3.36,4.79,6.18,5.17S264,414,262,414Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.29,364.11c-4.51-11.07-8.18-20.71-8.67-23.79,0,0-15.74.58-30,.78l-1.54-27.19s20.08,2.88,33.58,14.51C225.37,329.86,228.7,352.13,230.29,364.11Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.18,338.26h58.11a0,0,0,0,1,0,0v3.57a4.49,4.49,0,0,1-4.49,4.49H169.67a4.49,4.49,0,0,1-4.49-4.49v-3.57A0,0,0,0,1,165.18,338.26Z",
    transform: "translate(388.47 684.59) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.18,338.26h58.11a0,0,0,0,1,0,0v3.57a4.49,4.49,0,0,1-4.49,4.49H169.67a4.49,4.49,0,0,1-4.49-4.49v-3.57A0,0,0,0,1,165.18,338.26Z",
    transform: "translate(388.47 684.59) rotate(180)",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.27,398.58l-22.4-1.95V367.21H191v29.41l-22.48,2a3.87,3.87,0,0,0-3.49,3.85v3h59.74v-3A3.87,3.87,0,0,0,221.27,398.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.27,409.12a5.15,5.15,0,1,1-5.15-5.15A5.15,5.15,0,0,1,172.27,409.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222.66,
    cy: 409.12,
    r: 5.15,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.64,344.41h10.59a0,0,0,0,1,0,0v25.09a3.71,3.71,0,0,1-3.71,3.71h-3.16a3.71,3.71,0,0,1-3.71-3.71V344.41A0,0,0,0,1,189.64,344.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.64,344.41h10.59a0,0,0,0,1,0,0v25.09a3.71,3.71,0,0,1-3.71,3.71h-3.16a3.71,3.71,0,0,1-3.71-3.71V344.41A0,0,0,0,1,189.64,344.41Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.97,
    y: 343.23,
    width: 62.54,
    height: 4.03,
    rx: 1.81,
    transform: "translate(388.47 690.49) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.27,409.12a5.15,5.15,0,1,1-5.15-5.15A5.15,5.15,0,0,1,172.27,409.12Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222.66,
    cy: 409.12,
    r: 5.15,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.23,296.86H210.28c-5.26,0-9.06-4.73-8.48-10.55l.76-7.78c.58-5.83,5.3-10.56,10.56-10.56h17.95c5.26,0,9.06,4.73,8.49,10.56l-.77,7.78C238.22,292.13,233.49,296.86,228.23,296.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.23,296.86H210.28c-5.26,0-9.06-4.73-8.48-10.55l.76-7.78c.58-5.83,5.3-10.56,10.56-10.56h17.95c5.26,0,9.06,4.73,8.49,10.56l-.77,7.78C238.22,292.13,233.49,296.86,228.23,296.86Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.58,293.07H216c-3.11,0-5.36-2.79-5-6.24l.46-4.59c.33-3.45,3.13-6.24,6.24-6.24h10.6c3.11,0,5.36,2.79,5,6.24l-.46,4.59C232.48,290.28,229.69,293.07,226.58,293.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.16,286.21s-2.42,48.65-12.9,57h11.21s10-16.57,10.73-57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.18,265.94l1.93-1a2.57,2.57,0,0,1,2.34,0l3.46,1.7a4.74,4.74,0,0,1,2.59,3.51l.16.95c-3.09,1.94-7.85,1.76-7.85,1.76l-1.37.11a2.12,2.12,0,0,1-2.33-1.92l-.24-2.7A2.46,2.46,0,0,1,227.18,265.94Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.18,265.94l1.93-1a2.57,2.57,0,0,1,2.34,0l3.46,1.7a4.74,4.74,0,0,1,2.59,3.51l.16.95c-3.09,1.94-7.85,1.76-7.85,1.76l-1.37.11a2.12,2.12,0,0,1-2.33-1.92l-.24-2.7A2.46,2.46,0,0,1,227.18,265.94Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213,268.32l-7,8.85h-6.66l.87-12.35C205.25,265.79,213,268.32,213,268.32Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.41,277.17h-5.76l3.58-8.85S205.28,271.43,205.41,277.17Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.84,309.52l-29.31-2.72c.92-3.12,1.73-6.18,2.41-9.13.86-3.61,1.54-7.07,2.08-10.3s1-6.23,1.32-8.95l.09-.77c0-.43.1-.85.14-1.25.29-2.63.47-4.92.59-6.81.25-3.69.25-5.82.25-5.82a61.4,61.4,0,0,1,30.15,1.79C206.92,277.84,194.84,309.52,194.84,309.52Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.74,267.52h0a5.82,5.82,0,0,1-10.07.72l-1.27-1.89L181.84,264c2.62-1.55,3.65-6.51,4-10.77h0c.11-1.34.15-2.6.15-3.67l6.58,9a12.37,12.37,0,0,0-1,3,5.66,5.66,0,0,0-.1,1.3C191.48,264.61,192.35,266.23,194.74,267.52Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.55,258.61a12.37,12.37,0,0,0-1,3c-1.73,2.22-4.42,4.57-8.13,4.72L181.84,264c2.62-1.55,3.65-6.51,4-10.77h0c.11-1.34.15-2.6.15-3.67Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.74,243.58s-3.25-1.22-2.29-3.47,2.12-2.23,2.12-2.23a6.62,6.62,0,0,1-.12-6c1.61-3,5.17-1.78,5.17-1.78a4.15,4.15,0,0,1,3.3-4,4.38,4.38,0,0,1,4.68,2.46s2.24-2.91,5.52-2.11,3.94,5.37,3.94,5.37a3.66,3.66,0,0,1,4.56,2.19,5.62,5.62,0,0,1-.53,5.78s2.09-1,2.78,2.37-2.83,6.33-2.83,6.33,1.9.23.92,2.72-4.07,2.53-4.07,2.53,1.2.61-1.07,2.66-9.58-.88-9.58-.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.68,238.24c-7,.36-9,4.22-9.17,11.45-.17,9,2.16,15.31,10.79,12.93C199,259.39,197.28,237.63,185.68,238.24Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181,249.06a14.76,14.76,0,0,1-1.88,3,1.94,1.94,0,0,0,1.89.7Z",
    style: {
      fill: "#a24e3f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.25,248.26c0,.58.34,1,.72,1s.68-.48.67-1.06-.34-1-.73-1S185.23,247.69,185.25,248.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.07,247.23l-1.26-.46S185.46,247.81,186.07,247.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.1,248.35c0,.58.34,1,.73,1s.68-.48.66-1.06-.34-1-.72-1S178.09,247.78,178.1,248.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.93,247.31l-1.27-.45S178.32,247.89,178.93,247.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.15,244.63a.28.28,0,0,1-.22-.1,3.35,3.35,0,0,0-2.81-.8.3.3,0,0,1-.35-.24.3.3,0,0,1,.24-.34,3.87,3.87,0,0,1,3.36,1,.3.3,0,0,1,0,.42A.31.31,0,0,1,188.15,244.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.22,244.42a.32.32,0,0,1-.24-.11.3.3,0,0,1,.06-.42,3.58,3.58,0,0,1,3-.77.3.3,0,0,1,.2.38.3.3,0,0,1-.37.19h0a3,3,0,0,0-2.49.68A.31.31,0,0,1,177.22,244.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.93,249.61s-3.57-5.57-3.3-10c0,0-14.14-4.93-14.09,9.15,0,0-2-12.4,10-13.31s12.86,16.66,6.93,22.22C193.46,257.65,196.14,253.09,193.93,249.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.87,251.15a3.07,3.07,0,0,1,3.15-3c2.18.13,3.44,4.52-1.89,5.87C193.37,254.23,192.89,253.5,192.87,251.15Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.69,256.83a4.2,4.2,0,0,1-.6,0,.3.3,0,0,1-.24-.35.29.29,0,0,1,.34-.24,3.4,3.4,0,0,0,3.71-2,.3.3,0,0,1,.56.22A3.86,3.86,0,0,1,182.69,256.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.5,247.06c-1.67-8.67-14.49-15.95-19.3-5.87a13,13,0,0,1,4.47-6.36s13-3.71,15.29,11.1Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.67,414c-5,0-5.67-.08-8.49-.18-2.41-.08-3,.22-4.92.18-1.62,0-1.56-1.59-1.06-3.37.25-.9.63-2.79,1-4.23l7.34-.54c1,2,3.36,4.79,6.18,5.17S191.66,414,189.67,414Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166,306.18s-10,14.87-4.58,27.09,32.83,6.7,32.83,6.7l-18.06,66.46,8.64,1.43s30.63-65.87,31.41-77.1-32.29-18.44-32.29-18.44Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166,306.18s-10,14.87-4.58,27.09,32.83,6.7,32.83,6.7l-18.06,66.46,8.64,1.43s30.63-65.87,31.41-77.1-32.29-18.44-32.29-18.44Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.5,272s-14,9.86-25.07,5.62c0-.43.1-.85.14-1.25.29-2.63.47-4.92.59-6.81a67.54,67.54,0,0,1,11.13-3.95A36.85,36.85,0,0,0,196.5,272Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177,263.79c6.16,3,12.52,6.73,19.23,8.1,3.86-.25,8.18-1.82,12.06-2.88l11.63-3.52a2.1,2.1,0,0,1,1.63,3.85c-3.63,2-7.29,3.84-11.08,5.52-4.68,1.92-9,4.16-14.28,4.64a21.22,21.22,0,0,1-5.6-.82,83.31,83.31,0,0,1-17.64-7.47,4.23,4.23,0,0,1,4-7.42Z",
    style: {
      fill: "#b97864"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.69,262.68c-5.39,1.28-5.57,10.53-.62,14.87l12-10.13S180.08,261.16,173.69,262.68Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.23,265.54l6.65-.16-3,6.73s-6-.21-5.71-3.27Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "232.59 268.67 228.03 273.58 223.86 272.11 226.88 265.38 232.59 268.67",
    style: {
      fill: "#b97964"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M321.88,346.51c4.65,9.62,9.13,19.24,12.16,29.54,1.39,7,1.65,14.12,2.17,21.07.36,5.75.57,11.49.65,17.26l-5.15.54c-1.63-8.11-3.16-17.16-4.58-25.34-.68-3.7-1.2-7.34-2.13-10.9-3.54-9.17-8.45-18.61-12.52-27.63l9.4-4.54Z",
    style: {
      fill: "#dc897c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.56,359.1,321.41,363l-5.06,2.45-3.07-7.38-3.21-7.73,2.71-14.09C321.1,339.89,329.56,359.1,329.56,359.1Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.41,363l-5.06,2.45-3.07-7.38c.63-4.18,1.16-7.73,1.16-7.73S320.36,355.65,321.41,363Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297,310.7c.09.6.48,1,.87,1s.63-.59.54-1.19-.49-1-.88-1S296.85,310.11,297,310.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.37,311.74A21.65,21.65,0,0,0,301,316.4a3.48,3.48,0,0,1-2.76,1Z",
    style: {
      fill: "#de5753"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.25,307.73a.37.37,0,0,1-.24-.1.36.36,0,0,1,0-.5,3.47,3.47,0,0,1,3.06-1,.35.35,0,0,1,.27.42.35.35,0,0,1-.42.27h0a2.78,2.78,0,0,0-2.41.84A.35.35,0,0,1,294.25,307.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.86,319.74a10.38,10.38,0,0,1-2.91,6.42,10.18,10.18,0,0,1-4,2.53,9.24,9.24,0,0,1-8.67-1.41c-4.28-3.18-4.84-7.51-6.42-14.76a10.12,10.12,0,0,1,12.23-12.12C296.73,302.21,299.41,312.92,298.86,319.74Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.61,324.35c3,1.89,14.34-3.42,12.47-12.35,0,0,4.47-4.89,4.25-10.52s-4-8-8.12-6.94c-3.66.89-3.65,2.88-3.65,2.88s-17.16,1.21-13.84,8.32C263.42,313,275.92,322,279.61,324.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289,313.39a8.39,8.39,0,0,0,2.81,4.6c1.87,1.54,3.39.18,3.36-2,0-2-1-5.17-3.17-5.86S288.58,311.22,289,313.39Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.34,322.26a10.46,10.46,0,0,1-2.39,3.9,10.18,10.18,0,0,1-4,2.53,22.38,22.38,0,0,1-2.92-1.77l1.52-3.73S295.21,325.47,298.34,322.26Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.05,333.5l-1.28-8.77s5.71-4,11.69-1.31l9,10.85Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.5,333.19l-2.09-3.13s-15.16-5.61-21.77,1.58C278.64,331.64,293.43,339.46,302.5,333.19Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.5,333.19l-2.09-3.13s-15.16-5.61-21.77,1.58C278.64,331.64,293.43,339.46,302.5,333.19Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "244.29 418.22 238.58 414.54 240.77 411.27 246.72 402.39 252.44 406.07 245.86 415.88 244.29 418.22",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239,414.07l8-.08a.59.59,0,0,1,.56.45l1.34,5.81a1,1,0,0,1-.73,1.16l-.21,0c-2.58,0-4.45-.16-7.68-.13-2,0-8,.29-10.74.31s-3.14-2.68-2-2.94c5-1.15,8.82-2.71,10.42-4.18A1.57,1.57,0,0,1,239,414.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.54,409.06,251,411.88l56.78-43.08-29.13-6.38a10.48,10.48,0,0,0-11,4.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.54,409.06,251,411.88l56.78-43.08-29.13-6.38a10.48,10.48,0,0,0-11,4.57Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "209.5 418.43 203.6 415.06 205.62 411.68 211.09 402.5 216.99 405.87 210.94 416.01 209.5 418.43",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.83,413.93h8a.58.58,0,0,1,.56.45l1.29,5.83a1,1,0,0,1-.75,1.15l-.21,0c-2.57,0-4.45-.2-7.68-.2-2,0-8,.21-10.74.21s-3.11-2.72-2-3c5-1.1,8.85-2.62,10.47-4.07A1.61,1.61,0,0,1,203.83,413.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.48,391.42l-39.7.1c-1-3.52-2.26-15.77-6.14-30.92-1.05-4.11-2.3-8.43-3.77-12.86A95.5,95.5,0,0,0,267.43,336a35.66,35.66,0,0,1,11.66-4.49c17.57-3,33.69,4.74,33.69,4.74S319.75,355.65,321.48,391.42Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.64,360.6c-1.05-4.11-2.3-8.43-3.77-12.86l2.77-1.12S279,356.45,275.64,360.6Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.27,367.4l4.61,2.18,1.76-7.76s-3.68-1.29-6.44.59Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "269.49 372.21 269.7 365.14 264.64 361.82 262.88 369.58 269.49 372.21",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.64,348.15c-7.67,4.15-16.43,8-23.1,13.43-.15.13-.1.19.07-.39a2.59,2.59,0,0,0-.14-1.09,1.63,1.63,0,0,0-.69-.92c-.13-.05-.05.07.13.19a4.45,4.45,0,0,0,.79.39c3.08,1.17,7.35,1.56,10.8,2l.52,5.15c-1.09.31-2.11.52-3.18.72-4,.69-8.15,1.18-12.36-.21a7.27,7.27,0,0,1-4.93-8.84c2.06-7.31,20.7-16.43,27.54-19.82l4.55,9.4Z",
    style: {
      fill: "#dc897c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.91,383.07l-1.78,4.56s-21.27-26.28-33-27.78-39,48.44-39,48.44l10.34,3.13,29.1-26.4c12,20.94,26.35,36.3,43.41,36.3h16.66c18.63,0,18.84-20.78,15.16-38.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.43,336c-6.67,2.44-14.51,9.84-14.51,9.84s6.6,11.44,7.26,11,14.2-4.32,14.2-4.32,2.76-3.58.64-9.64A10.26,10.26,0,0,0,267.43,336Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.41,410.93l7.25.36-3.83,7.08s-6.45-.71-5.94-4Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "347.6 415.33 342.25 420.3 337.83 418.37 341.66 411.29 347.6 415.33",
    style: {
      fill: "#e4897b"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.72,339.22c4.86,4.9,9.65,10.39,15.47,14.1,0,0,.36.19.39.22a1.29,1.29,0,0,0-.49-.08c-.15,0,.09,0,.35,0,6.64-1.88,12.81-6.21,18.92-9.54a2.25,2.25,0,0,1,2.73,3.54c-4.76,4.41-17.59,16.2-24.33,13.73-4.12-1.51-7.56-4.35-10.8-7.08a96.54,96.54,0,0,1-8.93-8.82c-3.81-4.53,2.55-10.3,6.69-6.06Z",
    style: {
      fill: "#e9b376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.08,346.14c-.85,6.36-6,12.6-6,12.6L111,358l-5.26-3.49s-.1-.3-.25-.83-.34-1.15-.57-2c-1.21-4.24-3.39-12.17-3.66-15.46C107.79,336.07,110.73,339.18,118.08,346.14Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.08,346.14c-.85,6.36-6,12.6-6,12.6L111,358l-5.26-3.49s-.1-.3-.25-.83-.34-1.15-.57-2c-1.21-4.24-3.39-12.17-3.66-15.46C107.79,336.07,110.73,339.18,118.08,346.14Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111,358l-5.26-3.49s-.1-.3-.25-.83a39.56,39.56,0,0,1,.88-4.78A12.15,12.15,0,0,1,111,358Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.6,377.5l4.49,7.86c12-2.8,50.58-8.68,55.31,4.55,5.89,16.43-36.64,29.54-60.17,30.34s-44.06-4.8-29.18-39.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.6,377.5l4.49,7.86c12-2.8,50.58-8.68,55.31,4.55,5.89,16.43-36.64,29.54-60.17,30.34s-44.06-4.8-29.18-39.11Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.59,413.14a.17.17,0,0,1-.18,0,.14.14,0,0,1,0-.15c.08-.26.86-2.52,1.65-2.76a.5.5,0,0,1,.47.13.82.82,0,0,1,.28.76,2.13,2.13,0,0,1-.74,1.07A8.54,8.54,0,0,1,157.59,413.14Zm.2-.43a3.3,3.3,0,0,0,1.67-1.62.49.49,0,0,0-.19-.51.18.18,0,0,0-.19-.06.54.54,0,0,0-.18.11A6.52,6.52,0,0,0,157.79,412.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.54,413.17a.11.11,0,0,1-.14,0c-.08-.06-1.16-1.43-1-2.36a.85.85,0,0,1,.37-.57.53.53,0,0,1,.63-.06c.57.41.5,2.24.22,2.94l0,.07Zm-.61-2.68a.53.53,0,0,0-.19.32,3.17,3.17,0,0,0,.73,1.89c.17-.78.12-2.07-.22-2.3,0,0-.1-.08-.27,0l0,.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.22,417a.15.15,0,0,1,.15-.07.12.12,0,0,1,.11.1c.06.27.47,2.63-.1,3.22a.49.49,0,0,1-.48.1.77.77,0,0,1-.61-.53,2,2,0,0,1,.13-1.28A8.34,8.34,0,0,1,116.22,417Zm0,.48a3.36,3.36,0,0,0-.69,2.22.5.5,0,0,0,.43.36.17.17,0,0,0,.19,0,.52.52,0,0,0,.1-.18A6.46,6.46,0,0,0,116.25,417.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "131.62 405.09 121.94 408.54 117.29 410.2 118.48 415.29 122.98 414.33 133.98 411.98 131.62 405.09",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.75,415.53l-.82-6a.6.6,0,0,0-.69-.51l-3,.5s-4,.37-4.83,1.41c-2.34,3-.88,16.34.68,16.81.57.17,1.17-.61,1.42-1.15.79-1.72,2.18-6.21,2.86-7.63.78-1.67,3-2.48,3.92-2.77A.6.6,0,0,0,119.75,415.53Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.24,417a.13.13,0,0,1,.15,0c.09,0,1.71.7,2,1.59a.89.89,0,0,1-.06.68.5.5,0,0,1-.52.36c-.69-.08-1.52-1.72-1.61-2.46V417A.1.1,0,0,1,116.24,417Zm1.84,2.05a.62.62,0,0,0,0-.38c-.19-.57-1.09-1.07-1.55-1.3.22.77.89,1.87,1.3,1.91,0,0,.12,0,.21-.17l0-.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "131.62 405.09 121.94 408.54 122.98 414.33 133.98 411.98 131.62 405.09",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "124.7 415.2 127.48 415.4 125.62 405.82 122.46 407.56 124.7 415.2",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "124.7 415.2 127.48 415.4 125.62 405.82 122.46 407.56 124.7 415.2",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.31,378l14.5,16.08s16-.36,35.5,9.16c0,0,20.89-8.63,22.81-15.8,2.52-9.39-48-2.05-48-2.05Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.45,384.43,74.88,381a61.52,61.52,0,0,0,1-9.25,100.53,100.53,0,0,0-.52-13.25c-.41-4.21-1-9.05-2-14.73a6.94,6.94,0,0,1,6.93-8.28c1.19,0,2.44.06,3.72.14A95.55,95.55,0,0,1,97.5,337.2c1.44.29,2.93.65,4.36,1,5.13,1.33,8.31,7.79,7.87,13a89.56,89.56,0,0,1-1.34,12.07C107.48,369.15,106.41,374.89,104.45,384.43Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.45,384.43,74.88,381a61.52,61.52,0,0,0,1-9.25,100.53,100.53,0,0,0-.52-13.25c-.41-4.21-1-9.05-2-14.73a6.94,6.94,0,0,1,6.93-8.28c1.19,0,2.44.06,3.72.14A95.55,95.55,0,0,1,97.5,337.2c1.44.29,2.93.65,4.36,1,5.13,1.33,8.31,7.79,7.87,13a89.56,89.56,0,0,1-1.34,12.07C107.48,369.15,106.41,374.89,104.45,384.43Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9,371.76a100.53,100.53,0,0,0-.52-13.25c3.7-4.37,7.2-8,7.2-8S88.38,365.44,75.9,371.76Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.57,348.89c.34,6.33.28,16.18,1.43,22.23l-.3-.74c-.2-.29-.08,0,.13.16a9,9,0,0,0,.86.75c4,3,8.8,5.31,13.31,7.7l5.69,2.93a2.25,2.25,0,0,1-1.53,4.2c-2.17-.52-4.25-1.14-6.36-1.78-6-2-12.16-3.92-17.32-7.83a7.24,7.24,0,0,1-2.27-3c-2.31-8.2-2.49-16.12-2.66-24.48.21-5.83,8.65-5.94,9-.11Z",
    style: {
      fill: "#e9b376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.67,381.56l-1.8-1.31a2.57,2.57,0,0,0-2.34-.35l-3.7,1.24a4.84,4.84,0,0,0-3.08,3.18l-.28.93c2.84,2.36,7.65,2.83,7.65,2.83l1.35.28a2.15,2.15,0,0,0,2.6-1.61l.6-2.68A2.46,2.46,0,0,0,109.67,381.56Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.87,335.9c-5.78,2.07-7.44,7.11-7.56,17.62,3,2.73,12.11,2.88,12.11,2.88S84,340.46,77.87,335.9Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.89,387.35v2.38c0,.61-.72.86-1.33.86H99c-.62,0-1.35-.25-1.35-.86v-2.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.89,387.35v2.38c0,.61-.72.86-1.33.86H99c-.62,0-1.35-.25-1.35-.86v-2.38Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.89,387.35v2.38c0,.61-.72.86-1.33.86h-31.4c-.61,0-1.34-.25-1.34-.86v-2.38Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.86,362.61l-5.67,25.71a1.94,1.94,0,0,1-1.84,1.46h-31a1.25,1.25,0,0,1-1.16-1.62l5.66-25.51a1.77,1.77,0,0,1,1.84-1.26h31C155.52,361.39,156,361.77,155.86,362.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.86,362.61l-5.67,25.71a1.94,1.94,0,0,1-1.84,1.46H118.43a1.26,1.26,0,0,1-1.17-1.62l5.67-25.51a1.77,1.77,0,0,1,1.84-1.26h29.92C155.52,361.39,156,361.77,155.86,362.61Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.59,375.67h0a4.43,4.43,0,0,1-4.09,4c-1.73,0-2.76-1.79-2.26-4s2.21-3.92,3.9-4c-.49,2.2.57,4,2.29,4Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.5,348.28l6.66.17-3-6.74s-5.94.21-5.71,3.27Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "157.87 345.17 153.31 340.25 149.14 341.71 152.16 348.45 157.87 345.17",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.55,335.56c-.68-.05,1.4,8.3,11.5,10.36s9.32-7.23,8.53-9.56C102.58,336.36,89.3,336,82.55,335.56Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.32,302.91s5.79-6.42,16.38-3.11,10.14,22.21,4.76,29.07a98.58,98.58,0,0,0-25.08,2.34s-5.1-13.71-2.57-21.77S85.32,302.91,85.32,302.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.45,321.76c.67,4.46,1.19,12.54-2,15.1,0,0,4.16-.14,12.23,6.24,2.93-3.32,1.2-4.69,1.2-4.69-4.77-1.71-4.5-5.31-3.53-8.6Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.69,325.05l4.71,4.76a14,14,0,0,0-.51,2.36c-1.83-.48-4.28-2.81-4.39-4.78A6.57,6.57,0,0,1,90.69,325.05Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.76,312.66c.5,7.13.57,10.15,4.16,14,5.41,5.72,14,4,15.55-3,1.45-6.32.38-16.92-6.54-20.05A9.15,9.15,0,0,0,84.76,312.66Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.54,314.85c0,.61.33,1.1.72,1.12s.67-.46.66-1.06-.34-1.1-.72-1.11S93.52,314.25,93.54,314.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101,314.93c0,.6.34,1.1.72,1.12s.67-.46.66-1.06-.34-1.1-.72-1.11S101,314.33,101,314.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.46,313.9l1.39-.36S102.16,314.64,101.46,313.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.74,316.16a17.88,17.88,0,0,0,2.18,3.92,2.41,2.41,0,0,1-2.07.31Z",
    style: {
      fill: "#d58745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.34,311.05a.29.29,0,0,0,.25-.08,2.55,2.55,0,0,1,2.36-.6.32.32,0,0,0,.41-.23.37.37,0,0,0-.25-.45,3.2,3.2,0,0,0-3,.74.35.35,0,0,0,0,.49A.36.36,0,0,0,92.34,311.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.9,311.11a.35.35,0,0,0,.25,0,.34.34,0,0,0,.1-.48,3.68,3.68,0,0,0-2.68-1.85.32.32,0,0,0-.34.33.39.39,0,0,0,.34.38,2.9,2.9,0,0,1,2.11,1.48A.34.34,0,0,0,103.9,311.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94,313.82l1.39-.35S94.73,314.56,94,313.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.24,316.94s5.5-4.32,4.25-11.08c0,0,9.84-3.89,13.72,6,0,0,.82-8.48-8.43-10.14s-20.2,10.88-9.72,20.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.49,318.42a5.7,5.7,0,0,0,3.4,2.76c1.87.51,2.71-1.33,2.11-3.23-.55-1.71-2.18-4-4-3.71S81.56,316.73,82.49,318.42Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.29,316.06a.21.21,0,0,1-.2-.15c-3.53-12.43-15.18-9.87-15.3-9.85a.2.2,0,1,1-.09-.39c.12,0,12.15-2.67,15.78,10.13a.2.2,0,0,1-.14.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2,322.46a17.84,17.84,0,0,0-.86,2.52l-.47,0c-2.11-.23-3-1-3.38-1.85a2.77,2.77,0,0,1-.21-1.28,2.92,2.92,0,0,1,.14-.73,10,10,0,0,0,4.06,1.3C98.92,322.44,99.2,322.46,99.2,322.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.48,322.38l-.27.73c-2-.21-3.37-.63-3.93-1.3a2.92,2.92,0,0,1,.14-.73A10,10,0,0,0,98.48,322.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.87,324.94c-2.11-.23-3-1-3.38-1.85a7.09,7.09,0,0,1,2.3.71A2.59,2.59,0,0,1,97.87,324.94Z",
    style: {
      fill: "#de5753"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.53,355.78a.21.21,0,0,1-.17-.07,53.55,53.55,0,0,1-11.74-19.89.24.24,0,0,1,.17-.29.23.23,0,0,1,.28.17,52.94,52.94,0,0,0,11.36,19.39c.6-2,3.09-11.5-.66-18.78a.24.24,0,0,1,.42-.22c4.29,8.33.6,19.42.56,19.53a.25.25,0,0,1-.17.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.84,355.36l.76,1a.48.48,0,0,1,0,.6l-.77,1a.49.49,0,0,1-.75,0l-.72-.82a.48.48,0,0,1,0-.58L97,355.4A.5.5,0,0,1,97.84,355.36Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.87,335.9c-5.78,2.07-7.44,7.11-7.56,17.62,3,2.73,12.11,2.88,12.11,2.88S84,340.46,77.87,335.9Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "138.34 416.11 148.48 417.78 153.35 418.58 154.77 413.55 150.37 412.21 139.61 408.94 138.34 416.11",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.78,412.73l-2.19,5.64a.61.61,0,0,0,.36.79l2.83,1s3.71,1.62,4.91,1.1c3.51-1.51,8.68-13.88,7.54-15-.42-.43-1.32,0-1.8.32-1.52,1.12-4.91,4.37-6.19,5.29-1.5,1.08-3.79.74-4.78.53A.58.58,0,0,0,153.78,412.73Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "138.34 416.11 148.48 417.78 150.37 412.21 139.61 408.94 138.34 416.11",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.62,411.16S107.28,387.92,93,388.58s-16.32,13.24-10.44,21.11,16.76,9.79,16.76,9.79S91.93,409,93,406.08s5.25,1.16,5.25,1.16,26,8.4,48.77,10.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "149.29 410.52 146.95 408.95 143.94 418.18 147.55 418.18 149.29 410.52",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "149.29 410.52 146.95 408.95 143.94 418.18 147.55 418.18 149.29 410.52",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.6000000000000001
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTcaHeroCropped);
export default __webpack_public_path__ + "static/media/tca_hero-cropped.3643826e5a36bd9e2db0dca00ea0e24d.svg";
export { ForwardRef as ReactComponent };